import React from 'react';
import "./faq.scss";
import { Link } from 'react-router-dom';

const FAQS = () => {

    return (

        <>
            <div className="faq-seaction">
                <div className="faq-section-inner">
                    <h4>Frequently Asked Questions (FAQs)</h4>
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button style={{ boxShadow: "none" }} className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    What is Nearby Freelancers?
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Nearby Freelancers is an online platform connecting businesses with local freelance professionals for various projects and jobs.
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    How do I register as a freelancer?
                                </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    To register as a freelancer, visit our website, click on <Link to='/register-as-freelancer'>Freelancer Login</Link> fill in your details, and complete your profile

                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingThree">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    How do businesses post jobs or projects?
                                </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Businesses can post jobs or projects by creating an account and selecting "Post a Job" or "Post a Project" and providing the necessary details. Click <Link to='/job-recuiter-login'> here</Link> to Login
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFour">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    Is there a fee to join Nearby Freelancers?
                                </button>
                            </h2>
                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Registration is free. We offer various subscription plans for freelancers to apply for jobs and projects and access premium features.
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFive">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    What types of jobs and projects are available?
                                </button>
                            </h2>
                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    We offer a wide range of jobs and projects across different industries, including IT, design, writing, marketing, and more.
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingSix">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    How can I find local projects?
                                </button>
                            </h2>
                            <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Use our search filters to narrow down projects based on your location and skills.
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingSeven">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    How do payments work?
                                </button>
                            </h2>
                            <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Payments are securely processed through our platform by use of an escrow account. Freelancers receive payments directly into their accounts after completing a project.
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingeleven">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseeleven" aria-expanded="false" aria-controls="collapseeleven">
                                    How does escrow account work ?
                                </button>
                            </h2>
                            <div id="collapseeleven" className="accordion-collapse collapse" aria-labelledby="headingeleven" data-bs-parent="#accordionExample">
                                <div className="accordion-body">

                                    An escrow account is a third-party account used to hold funds, documents, or assets during a transaction until certain conditions are met. It provides security for both the buyer and the seller by ensuring that neither party can access the funds or assets until all agreed-upon obligations are fulfilled.
 


                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingEight">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                    What is the refund and cancellation policy?
                                </button>
                            </h2>
                            <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Our refund and cancellation policies are clearly outlined on our website. Please refer to the <Link to='/privacy-and-policy'>policy page</Link>  for detailed information.
                                </div>
                            </div>
                        </div>
                       
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTen">
                                <button style={{ boxShadow: "none" }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                                    How do I communicate with clients or freelancers?
                                </button>
                            </h2>
                            <div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Use our built-in messaging system to communicate securely with clients or freelancers.
                                </div>
                            </div>
                        </div>
                      
                    </div>
                </div>
            </div>

        </>
    )
}

export default FAQS 
